const BASE_DOMAIN = Object.freeze({
  PRODUCTION: 'squareup.com',
  STAGING: 'squareupstaging.com',
});

const getEnvironment = () => {
  const envMeta = document.querySelector("meta[name='sq:environment']");
  if (!envMeta) {
    return null;
  }

  return JSON.parse(envMeta.getAttribute('content'));
};

// The sq:environment meta tag can be absent on crawler-rendered pages
// (e.g. Google Storebot). Assume production in that case rather than
// crashing with "Cannot read properties of null (reading 'env')".
const getDomain = (otherSubdomain) => {
  const { env = 'production', app_subdomain = 'app.' } = getEnvironment() || {};
  const host =
    env === 'production' ? BASE_DOMAIN.PRODUCTION : BASE_DOMAIN.STAGING;

  // other subdomains do not need the 'app' subdomain too
  const subdomain =
    otherSubdomain || otherSubdomain === '' ? otherSubdomain : app_subdomain;

  return `${subdomain}${host}`;
};

const getHost = () => {
  const { env = 'production' } = getEnvironment() || {};
  return env === 'production'
    ? 'https://api.squareup.com'
    : 'https://api.squareupstaging.com';
};

export { BASE_DOMAIN, getEnvironment, getDomain, getHost };
